import { replaceKeywordValue } from "@/domain/keyword-types";
import { stringifyFootprint, stringifyUnitType } from "@/domain/units";
import { numericalStat } from "@/lib/numerical-stat";
import { useState } from "react";
import { Fragment } from "react/jsx-runtime";
import { FauxDialogLayout } from "../faux-dialog-layout";
import { useRuleset } from "../game-content-provider";
import { useKeywords } from "../keywords-handler";
import { Table } from "../table";
import * as css from "./style.css";

export function UnitProfiles() {
  const ruleset = useRuleset();
  const peekKeyword = useKeywords();
  const [isTableOverflowing, setIsTableOverflowing] = useState(false);

  return (
    <FauxDialogLayout heading="Unit Profiles" theme="dark">
      {!isTableOverflowing && (
        <p className={css.scrollHint}>Scroll horizontally to explore the table →</p>
      )}

      <div style={{ marginBlockStart: "2rem" }}>
        <Table
          size="large"
          onTableOverflow={setIsTableOverflowing}
          columns={[
            {
              label: "Unit Type",
              key: "type",
              width: "14%",
              align: "left",
              sticky: true,
              getRowData: (unitProfile) => {
                return {
                  value: stringifyUnitType(unitProfile.type),
                  align: "left",
                  sticky: true,
                  heading: true,
                };
              },
            },
            {
              label: "Speed",
              key: "speed",
              getRowData: (unitProfile) => ({ value: `${unitProfile.speed}` }),
            },
            {
              label: "Range",
              key: "range",
              getRowData: (unitProfile) => ({ value: numericalStat(unitProfile.range, "″") }),
            },
            {
              label: "Strikes",
              key: "strikes",
              getRowData: (unitProfile) => ({ value: `${unitProfile.strikes}` }),
            },
            {
              label: "Courage",
              key: "courage",
              getRowData: (unitProfile) => ({ value: `${unitProfile.courage}` }),
            },
            {
              label: "Footprint",
              key: "footprint",
              getRowData: (unitProfile) => ({ value: stringifyFootprint(unitProfile.footprint) }),
            },
            {
              label: "Multiplier",
              key: "multiplier",
              getRowData: (unitProfile) => ({ value: `${unitProfile.keywordsCostMultiplier}x` }),
            },
            {
              label: "Points",
              key: "points",
              getRowData: (unitProfile) => ({ value: `${unitProfile.points}pts` }),
            },

            {
              label: "Keywords",
              key: "keywords",
              align: "left",
              width: "24%",
              getRowData: (unitProfile) => {
                return {
                  align: "left",
                  value: (
                    <>
                      {unitProfile.defaultKeywords.map((kw, i) => {
                        const keyword = ruleset.keywordsDefsById.get(kw.id);
                        if (!keyword) {
                          return null;
                        }

                        const keywordName =
                          kw.numerical ?
                            replaceKeywordValue(keyword.name, kw.numerical.value)
                          : keyword.name;

                        return (
                          <Fragment key={kw.id}>
                            {i !== 0 ? ", " : null}

                            <button
                              className={css.keyword}
                              type="button"
                              onClick={() => {
                                peekKeyword({ id: kw.id });
                              }}
                            >
                              {keywordName}
                            </button>
                          </Fragment>
                        );
                      })}
                    </>
                  ),
                };
              },
            },
          ]}
          getItemDataKey={(unitProfile) => unitProfile.type}
          items={ruleset.unitProfiles}
        />
      </div>
    </FauxDialogLayout>
  );
}
